/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsExportGipAltReportQueryResponse, AuditReportsExportGipAltReportPathParams, AuditReportsExportGipAltReportQueryParams, AuditReportsExportGipAltReport400, AuditReportsExportGipAltReport401, AuditReportsExportGipAltReport403, AuditReportsExportGipAltReport404 } from "../models/AuditReportsExportGipAltReport";

export function getAuditReportsExportGipAltReportUrl(id: AuditReportsExportGipAltReportPathParams["id"]) {
  const res = { method: 'GET', url: `/audit-reports/v1/reports/gip-alt/report/${id}/export` as const }
  return res
}

/**
 * @summary Export existing report
 * {@link /audit-reports/v1/reports/gip-alt/report/:id/export}
 */
export async function auditReportsExportGipAltReport(id: AuditReportsExportGipAltReportPathParams["id"], params: AuditReportsExportGipAltReportQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditReportsExportGipAltReportQueryResponse, ResponseErrorConfig<AuditReportsExportGipAltReport400 | AuditReportsExportGipAltReport401 | AuditReportsExportGipAltReport403 | AuditReportsExportGipAltReport404>, unknown>({ method : "GET", url : getAuditReportsExportGipAltReportUrl(id).url.toString(), params, ... requestConfig })
  return res.data
}